import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nl from "./locales/nl.json";

// Only Dutch (default + fallback) ships in the main bundle; other languages load on demand.
const loaders = {
  en: () => import("./locales/en.json"),
  fr: () => import("./locales/fr.json"),
  de: () => import("./locales/de.json"),
};
const loadLanguage = (lng) => {
  const code = (lng || "").slice(0, 2);
  if (!loaders[code] || i18n.hasResourceBundle(code, "translation")) return Promise.resolve();
  return loaders[code]().then((m) => i18n.addResourceBundle(code, "translation", m.default || m, true, true));
};

const PATH_LANG = (window.location.pathname.split("/")[1] || "").slice(0, 2);

i18n
  .use(initReactI18next)
  .init({
    lng: loaders[PATH_LANG] ? PATH_LANG : "nl",
    resources: { nl: { translation: nl } },
    partialBundledLanguages: true,
    react: { bindI18nStore: "added" },
    fallbackLng: "nl",
    supportedLngs: ["nl", "en", "fr", "de"],
    load: "languageOnly",
    interpolation: { escapeValue: false },
  });

i18n.on("languageChanged", loadLanguage);
export const i18nReady = loadLanguage(PATH_LANG).catch(() => {});

export const LANGUAGES = [
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
];

export default i18n;
